export const clamp = (value: number, min: number, max: number) => {
  const x = value < min ? min : value;
  return x > max ? max : x;
};
